var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Metrics_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import '@symon-ai/wisepipe-base-computation'; // force import for JsonSchema
const schema = {
    $id: 'urn:wisepipe-common-computation:Metrics',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['calc', 'run'] },
        metrics: { type: 'array', items: { $ref: 'urn:wisepipe-base-computation:Metric' } }
    },
    // type determines the length of id
    // NOTE: 'if on a missing property' evaluates to true in the JSON Schema spec.
    // https://github.com/ajv-validator/ajv/issues/913
    // Add a required: ['type'] to the test to get the behavior most would expect.
    if: { properties: { type: { const: 'calc' } }, required: ['type'] },
    then: { properties: { id: { type: 'string', uid: 10 } }, required: ['id'] },
    else: {
        if: { properties: { type: { const: 'run' } }, required: ['type'] },
        then: { properties: { id: { type: 'string', uid: 9 } }, required: ['id'] }
    },
    required: ['type', 'metrics']
};
let Metrics = Metrics_1 = class Metrics {
    constructor(type, id, metrics) {
        this.type = type;
        this.id = id;
        this.metrics = metrics;
        JSON.validate(this, Metrics_1);
    }
};
Metrics = Metrics_1 = __decorate([
    JsonSchema(schema)
], Metrics);
export { Metrics };
//# sourceMappingURL=metrics.js.map